import Login from "~/features/Auth/pages/Login";
import {EmptyLayout} from "~/layout";
import UserInfo from "~/features/Info/pages";

export const publicRoutes = [
	{ path: "/login", component: Login, layout: EmptyLayout },
	{ path: "/info/:username/:token", component: UserInfo, layout: EmptyLayout },
];